import { INTERNAL_ROUTER } from '../utils/globals.mjs';
import { cullDecendants } from '../utils/createCullableNode.mjs';
import { getInternalRouter } from '../utils/getInternalRouter.mjs';

const ROUTE_DELIMITER = '\n'.repeat(3);
/**
 * Conditionaly render if passed URL matches current location.
 * It is possible to pass the components to render as children, or via `routeRender`, but it is preferable to use `routeRender` for faster computation.
 * @usage ./Route.usage.md
 */
const Route = ({ url, exact, strict, routeRender }, children, utils) => {
    const match = getInternalRouter().match({
        exact,
        path: url,
        strict,
    });
    if (!match) {
        cullDecendants(children, utils);
        return null;
    }
    if (routeRender) {
        return [
            routeRender({
                history: window[INTERNAL_ROUTER].history,
                match: match,
            }),
            ROUTE_DELIMITER,
        ];
    }
    return [
        utils.map(children, (child) => (Object.assign(Object.assign({}, child), { vattrs: Object.assign(Object.assign({}, child.vattrs), { match, history: window[INTERNAL_ROUTER].history }) }))),
        ROUTE_DELIMITER,
    ];
};

export { ROUTE_DELIMITER, Route };
